"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKHighlightText = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
require("./GKHighlightText.css");
// "Private" (non-exported) utility functions ---------------------
var highlight = function (text, i) { return (React.createElement("span", { key: "hlt-" + i, className: "gk-highlight" }, text)); };
/** internal utility function - insert open and close tags around first match */
var matchFirst = function (original, base, pattern) {
    var matchIndex = base.indexOf(pattern);
    if (matchIndex >= 0) {
        return [
            original.substring(0, matchIndex),
            highlight(original.substring(matchIndex, matchIndex + pattern.length), 1),
            original.substring(matchIndex + pattern.length),
        ];
    }
    else {
        return [original];
    }
};
/** internal utility function - insert open and close tags around each match (custom implementation for performance) */
var matchAll = function (original, base, pattern) {
    var result = [];
    var iOriginal = 0;
    var iLastMatch = 0;
    for (var iBase = 0; iBase < base.length; iBase++) {
        if (base[iBase] === pattern[iBase - iOriginal]) {
            if (iBase - iOriginal === pattern.length - 1) {
                result.push(original.slice(iLastMatch, iOriginal));
                result.push(highlight(original.slice(iOriginal, iOriginal + pattern.length), iOriginal));
                iLastMatch = iOriginal = iBase + 1;
            }
        }
        else if (iOriginal !== iBase && base[iBase] === pattern[0]) {
            iOriginal = iBase;
        }
        else {
            iOriginal = iBase + 1;
        }
    }
    result.push(original.slice(iLastMatch));
    return result;
};
var buildNewChildren = function (original, pattern, caseSensitive, all) {
    if (pattern instanceof RegExp) {
        var marker = "@@";
        return original
            .replace(pattern, marker + "$&" + marker)
            .split(marker)
            .map(function (s, i) { return (i % 2 === 1 ? highlight(s, i) : s); });
    }
    var comparisonBase = (!caseSensitive && original.toLowerCase()) || original;
    var comparisonPattern = (!caseSensitive && pattern.toLowerCase()) || pattern;
    var matchFunc = all ? matchAll : matchFirst;
    return matchFunc(original, comparisonBase, comparisonPattern);
};
/**
 * Component which provides an easy way to highlight text given a matching string or RegExp. Note that any forwarded styles
 * will be applied to the surrounding span rather than to the highlighted text itself
 */
var GKHighlightText = function (_a) {
    var children = _a.children, match = _a.match, caseSensitive = _a.caseSensitive, allOccurrences = _a.allOccurrences, otherProps = __rest(_a, ["children", "match", "caseSensitive", "allOccurrences"]);
    if (!((children instanceof Array && typeof children[0] === "string") ||
        typeof children === "string")) {
        return React.createElement(React.Fragment, null,
            " ",
            children,
            " ");
    }
    var str = children instanceof Array ? children.join("") : children;
    var newChildren = buildNewChildren(str, match, caseSensitive, allOccurrences);
    return (React.createElement("span", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
        _gkComponentName: "gk-highlight-text",
    })), newChildren));
};
exports.GKHighlightText = GKHighlightText;
